// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-primary[data-v-f884bdfa]{border:1px solid var(--v-primary-base)!important}.cursor-pointer[data-v-f884bdfa]{cursor:pointer}.transition-swing[data-v-f884bdfa]{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}", ""]);
// Exports
module.exports = exports;
